import React from 'react';
import Weblayout from './Weblayout';
import PageTransition from '../components/PageTransition';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { appname } from "../variables";

export default function Terms() {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <Weblayout isLegal={true}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bento-item p-0 border-0 bg-white overflow-hidden d-flex flex-column h-100 shadow-lg"
          style={{ borderRadius: '24px' }}
        >
          {/* HEADER SECTION */}
          <div className="bg-light border-bottom p-4 flex-shrink-0 d-flex justify-content-between align-items-center">
            <div>
              <h2 className="fw-black text-dark m-0">Terms of Service</h2>
              <small className="text-muted font-monospace">AGREEMENT_TYPE: SAAS_V1.0</small>
            </div>
            <div className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-3 py-2">
              <i className="bi bi-file-earmark-text me-1"></i> OFFICIAL_DOCUMENT
            </div>
          </div>

          {/* SCROLLABLE CONTENT BODY */}
          <div className="p-4 p-md-5 overflow-auto text-dark privacy-content flex-grow-1">
            
            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">01_ACCEPTANCE</h6>
              <h4 className="fw-black text-dark mb-3">Service Agreement</h4>
              <p>
                By accessing {appname}, you agree to be bound by these Terms of Service. This is a legal agreement between you (The User) and {appname}. If you are using the service on behalf of a company, you represent that you have the authority to bind that entity to these terms.
              </p>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">02_WHATSAPP_COMPLIANCE</h6>
              <h4 className="fw-black text-dark mb-3">API Usage & Messaging Policy</h4>
              <p>As a provider of WhatsApp API automation, we strictly enforce Meta's Business Policies:</p>
              <ul className="list-group list-group-flush border-start border-primary border-4 ms-2">
                <li className="list-group-item border-0"><strong>Opt-in Requirement:</strong> You must obtain explicit consent from users before sending proactive messages.</li>
                <li className="list-group-item border-0"><strong>Prohibited Content:</strong> Use of our API for spam, adult content, illegal drugs, or deceptive marketing is strictly forbidden.</li>
                <li className="list-group-item border-0"><strong>24-Hour Window:</strong> Customer-initiated conversations allow for free-form replies only within the 24-hour service window.</li>
              </ul>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">03_BILLING_CYCLES</h6>
              <h4 className="fw-black text-dark mb-3">Subscriptions & Payments</h4>
              <p>
                Access to our clusters is provided via subscription plans. 
                <strong> All payments are processed upfront</strong> on a monthly or yearly basis. Failure to renew will result in the suspension of your API nodes and message queuing services.
              </p>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">04_ACCOUNT_SECURITY</h6>
              <h4 className="fw-black text-dark mb-3">User Responsibility</h4>
              <p>
                You are solely responsible for maintaining the confidentiality of your API keys and session tokens. {appname} is not liable for any unauthorized access resulting from compromised user credentials.
              </p>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">05_SERVICE_AVAILABILITY</h6>
              <h4 className="fw-black text-dark mb-3">Uptime & Limitations</h4>
              <p>
                We aim for 99.9% uptime. However, since our service depends on the WhatsApp Cloud API (Meta), we are not responsible for downtimes caused by Meta infrastructure or regional internet outages.
              </p>
            </section>

            <section className="mb-4">
              <div className="p-4 rounded-4 bg-primary text-white d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 shadow">
                <div>
                  <h5 className="fw-bold m-0">Ready to deploy your first node?</h5>
                  <small className="opacity-75">By continuing, you confirm that you have read and understood these terms.</small>
                </div>
                <button className="btn btn-light rounded-pill px-4 fw-bold" onClick={() => navigate('/register')}>
                  ACCEPT_AND_PROCEED
                </button>
              </div>
            </section>

          </div>
        </motion.div>
      </Weblayout>
    </PageTransition>
  );
}